import React from 'react';
import { Link } from 'react-router-dom';
import LazyImage from '../LazyImage';
import Icon from '../icons/Icon';
import { calculateReadingTime } from '../../utils/readingTime';
import './BlogCard.css';

const BlogCard = ({ post }) => {
  const formatDate = (date) => {
    if (!date) return '';
    const d = date instanceof Date ? date : date.toDate();
    return d.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const readingTime = post.content ? calculateReadingTime(post.content) : 1;

  return (
    <article className="blog-card">
      {post.imageUrl && (
        <div className="blog-card-image">
          <LazyImage src={post.imageUrl} alt={post.title} />
        </div>
      )}
      <div className="blog-card-content">
        <div className="blog-card-meta">
          <span className="blog-card-category">{post.category}</span>
          <span className="blog-card-date">{formatDate(post.publishedAt)}</span>
          <span className="blog-card-reading-time">
            <Icon name="clock" size={14} /> {readingTime} {readingTime === 1 ? 'min' : 'mins'} read
          </span>
        </div>
        <h2 className="blog-card-title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h2>
        {post.excerpt && (
          <p className="blog-card-excerpt">{post.excerpt}</p>
        )}
        <div className="blog-card-tags">
          {post.tags && post.tags.slice(0, 3).map((tag, index) => (
            <span key={index} className="blog-card-tag">{tag}</span>
          ))}
        </div>
        <Link to={`/blog/${post.slug}`} className="blog-card-read-more">
          Read More →
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;

